import { getTaskByIdDoc } from '@griply/services';
import { doc, DocumentReference, getDoc } from 'firebase/firestore';
import { ID } from 'shared/types/id';

import { taskConverter } from './converters/task';
import { getDatabase } from './helpers';

export const getTaskById = async (id: ID) => {
  return getTaskByIdDoc<DocumentReference, ReturnType<typeof getDatabase>>({
    db: getDatabase(),
    doc,
    taskId: id,
  }).withConverter(taskConverter);
};

export const getTaskDocById = async (id: ID) => {
  const query = await getTaskById(id);
  const snapshot = await getDoc(query);
  return snapshot.data();
};
